export default __webpack_public_path__ + "static/media/autorep1.0ad3e9df.jpg";